<template>
  <div class="waste-type-search u-12/12@xs u-6/12@md u-push-3/12@md u-4/12@lg u-push-4/12@lg u-relative@xs u-absolute@md">
    <div class="waste-type-search__input-wrapper">
      <ElInput ref="input" v-model="keyword" size="large" placeholder="Wat wilt u weggooien?" suffix-icon="el-icon-search" />
      <ElButton v-if="keyword.length" class="clear-button" type="text" @click="clear">
        <i class="fa fa-times-circle" />
      </ElButton>
    </div>

    <div v-if="showResults" :class="{ 'show-results': keyword.length > 0 }" class="waste-type-search__results">
      <div style="margin-top: 60px;">
        <ul v-if="results.length > 0">
          <li
            v-for="(result, index) in results.slice(0, 5)"
            :key="index"
            :class="{ 'active-result': arrowIndex === index }"
            @mouseover="setActive(index)"
            @mouseleave="setActive(null)"
          >
            <!-- eslint-disable vue/no-v-html -->
            <a
              href="javascript:void(0)"
              @click="setActiveWasteType(result.title, result.garbageTypeId)"
              v-html="$options.filters.highlight(result.title, keyword)"
            ></a>
            <!-- eslint-enable vue/no-v-html -->
          </li>
        </ul>

        <div v-else class="u-ph-10">
          <FeedbackForm
            :payload="{ keyword: keyword, activeWasteStreamId: activeWasteStreamId }"
            custom-cta="Geen resultaten gevonden"
            custom-textarea-placeholder="Waar was u naar op zoek?"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import axios from 'axios'
import qs from 'qs'
import store from '../Store/store'
import { Button, Input } from 'element-ui'
import FeedbackForm from '../../components/FeedbackForm.vue'

export default {
  components: {
    ElButton: Button,
    ElInput: Input,
    FeedbackForm
  },
  filters: {
    highlight(words, query) {
      const iQuery = new RegExp(query, 'ig')
      return words.toString().replace(iQuery, function(matchedTxt, a, b) {
        return '<strong>' + matchedTxt + '</strong>'
      })
    }
  },
  props: {
    municipalityId: VueTypes.number.def(1)
  },
  data() {
    return {
      keyword: '',
      arrowIndex: null,
      previouslySentQuery: null,
      timeFromStart: 0,
      timer: null
    }
  },
  computed: {
    results() {
      if (this.wasteGroupSynonyms.length > 0 && this.keyword.length > 0) {
        return this.wasteGroupSynonyms.filter(woord => woord.title.toLowerCase().includes(this.keyword.toLowerCase()))
      } else {
        return []
      }
    },
    wasteGroupSynonyms() {
      return store.getters['waste/getWasteGroupSynonyms']
    },
    activeSynonym() {
      return store.getters['waste/getActiveSynonym']
    },
    activeWasteStreamId() {
      return store.getters['waste/getActiveWasteStreamId']
    },
    showResults() {
      return store.getters['waste/getShowResults']
    }
  },

  watch: {
    activeSynonym() {
      if (!this.activeSynonym) {
        this.keyword = ''
      }
    }
  },

  mounted() {
    store.dispatch('waste/populateStoreWithSynonyms')

    this.$nextTick(() => {
      this.$refs.input.focus()

      document.querySelector('.waste-type-search input.el-input__inner').addEventListener('keyup', e => {
        this.startQueryInterval()

        if (!this.showResults) {
          store.dispatch('waste/setShowResults', true)
        }

        if (e.key === 'Escape') {
          this.clear()
        }

        if (e.key === 'Backspace' && this.keyword.length === 0) {
          this.clear()
        }

        if (e.key === 'ArrowDown' && this.results.length > 0) {
          if (this.arrowIndex === null) {
            this.arrowIndex = 0
          } else if (this.arrowIndex === 4) {
            this.arrowIndex = 0
          } else {
            this.arrowIndex = this.arrowIndex + 1
          }
        }

        if (e.key === 'ArrowUp' && this.results.length > 0) {
          if (this.arrowIndex === null) {
            this.arrowIndex = 4
          } else if (this.arrowIndex === 0) {
            this.arrowIndex = 4
          } else {
            this.arrowIndex = this.arrowIndex - 1
          }
        }

        if (e.key === 'Enter' && this.results.length > 0 && this.arrowIndex < 5 && this.arrowIndex >= 0) {
          this.setActiveWasteType(this.results[this.arrowIndex].title, this.results[this.arrowIndex].garbageTypeId)
        }
      })
    })
  },

  methods: {
    setActiveWasteType(title, id) {
      this.keyword = title
      store.dispatch('waste/setShowResults', false)
      store.dispatch('waste/getWasteTypeData', { municipalityId: this.municipalityId, id: id.toString(), title: title })
    },
    clear() {
      this.keyword = ''
      this.arrowIndex = null
      this.$refs.input.focus()
      store.dispatch('waste/setShowResults', true)
      store.dispatch('waste/clearActiveSynonymAndWasteStreamId')
      store.dispatch('waste/clearActiveWasteType')
    },
    setActive(index) {
      this.arrowIndex = index
    },
    startQueryInterval() {
      clearInterval(this.timer)
      this.timeFromStart = 0
      this.timer = setInterval(() => {
        this.timeFromStart = this.timeFromStart + 100
        if (this.timeFromStart === 800 && this.results.length === 0 && this.keyword !== this.previouslySentQuery && this.keyword.length > 0) {
          this.previouslySentQuery = this.keyword
          this.sendAttemptedQuery()
        }
      }, 100)
    },
    sendAttemptedQuery() {
      const payload = {
        pageID: window.pageID,
        type: 'WASTE_WIZARD_QUERY',
        query: this.keyword
      }

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      axios.post(`${location.origin}/api/rating.php`, qs.stringify(payload), config)
    }
  }
}
</script>
